// extracted by mini-css-extract-plugin
module.exports = {"addressList":"SavedAddresses_addressList__L1iR_","heading":"SavedAddresses_heading___AsCo","address":"SavedAddresses_address__CxqZd"};